import { UserAPI } from '../../utils/API/UserAPI';
import {takeLatest, select, put} from 'redux-saga/effects';
import {selectCurrentUser} from "../selectors/app.selectors";
import {moduleIds} from "../../utils/models/Module";
import {selectGeofences} from "../selectors/geofence.selector";
import {selectTeams} from "../selectors/team.selector";
import {setDeviceToConnect} from "../../containers/ConnectDeviceDialog/actions";
import Device from "../../utils/models/Device";
import {
    CONNECT_APP,
    GET_APP_SEATS,
    UPDATE_USER,
    GET_USERS,
    SEND_APP_WELCOME_MAIL,
    WS_DATA_USERS,
    SEND_WELCOME_MAIL, CHANGE_APP_TYPE,
    GET_PTT_SEATS, TOGGLE_PTT
} from "../constants/user.constants";
import {appSeatsChanged, pttSeatsChanged, setError, setLoading, usersChanged} from "../actions/user.actions";

const api = new UserAPI();

function* getUsersSaga() {
    const users = yield api.getUsers();
    yield put(usersChanged(users));
}

function* updateUserSaga({user, inviteForApp, informUser, appType, callback}) {
    if(!callback) callback = () => {};
    if(user.id) {
        const res = yield api.updateUser(user, inviteForApp, appType);
        if(res === 'existing') {
            yield put(setError('existingUser.error'));
            yield put(setLoading(false));
            return callback(false);
        }
    } else {
        const res = yield api.addUser(user, informUser, inviteForApp, appType);
        if(res === 'existing') {
            yield put(setError('existingUser.error'));
            yield put(setLoading(false));
            return callback(false);
        }
        if(user.isAppOnly) {
            yield put(setDeviceToConnect(new Device(res.appDevice)));
        }
    }
    const newUsers = yield api.getUsers(true);
    yield put(usersChanged(newUsers));
    callback(true);
}

function* connectAppSaga({user, inviteForApp}) {
    const appDevice = yield api.connectApp(user, inviteForApp);
    const newUsers = yield api.getUsers(true);
    yield put(usersChanged(newUsers));

    const currentUser = yield select(selectCurrentUser);
    if(!currentUser.hasModule(moduleIds.Teams) && !currentUser.hasModule(moduleIds.Geofences)) return;
    const geofences = yield select(selectGeofences);
    const teams = yield select(selectTeams);
    if(!geofences.size && !teams.size) return;

    if(appDevice) {
        yield put(setDeviceToConnect(new Device(appDevice)));
    }
}
function* getAppSeatsSaga() {
    const appSeats = yield api.getAppSeats();
    yield put(appSeatsChanged(appSeats));
}
function* getPttSeatsSaga() {
    const pttSeats = yield api.getPttSeats();
    yield put(pttSeatsChanged(pttSeats));
}
function* togglePttSaga({user}) {
    yield api.togglePtt(user);
}
function* sendAppWelcomeMailSaga({user}) {
    yield api.sendAppWelcomeMail(user.email);
}
function* sendWelcomeMailSaga({user}) {
    yield api.sendWelcomeMail(user.email);
}
function *changeAppTypeSaga({device}) {
    yield api.changeAppType(device);
}

export const userSagas = [
    takeLatest(GET_USERS, getUsersSaga),
    takeLatest(GET_APP_SEATS, getAppSeatsSaga),
    takeLatest(GET_PTT_SEATS, getPttSeatsSaga),
    takeLatest(CONNECT_APP, connectAppSaga),
    takeLatest(CHANGE_APP_TYPE, changeAppTypeSaga),
    takeLatest(TOGGLE_PTT, togglePttSaga),
    takeLatest(SEND_APP_WELCOME_MAIL, sendAppWelcomeMailSaga),
    takeLatest(SEND_WELCOME_MAIL, sendWelcomeMailSaga),
    takeLatest(WS_DATA_USERS, getAppSeatsSaga),
    takeLatest(WS_DATA_USERS, getPttSeatsSaga),
    takeLatest(UPDATE_USER, updateUserSaga)
];